// extracted by mini-css-extract-plugin
module.exports = {"photo-story":"_2rQpc","heading-top-margin":"_1vJW9","story-body":"qEely","story-content":"_1sdma","author-wrapper":"_1XBB9","photo-slider":"PQSZW"};